import './hotspot.scss';

class Hotspot {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-hotspot',
            tooltipValue: 'tooltip',
            markerValue: 'marker',
            contentValue: 'content',
            positionAttr: 'data-hotspot-position'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$$tooltips = this.$root.querySelectorAll(`[${this.settings.initAttr}="${this.settings.tooltipValue}"]`);
    }

    initialize () {
        // Set marker positions
        if (this.$$tooltips.length > 0) {
            this.$$tooltips.forEach($tooltip => {
                this.positionTooltip($tooltip);
            });
        }

        this.setEvents();
    }

    positionTooltip (tooltip) {
        const $marker = tooltip.querySelector(`[${this.settings.initAttr}="${this.settings.markerValue}"]`);
        const $content = tooltip.querySelector(`[${this.settings.initAttr}="${this.settings.contentValue}"]`);

        if ($marker && $content) {
            const position = JSON.parse(tooltip.getAttribute(this.settings.positionAttr));

            // Position marker
            $marker.style.setProperty('--top', `${position.top}%`);
            $marker.style.setProperty('--left', `${position.left}%`);

            // Position and align content based on marker position
            if (position.top < 50 && position.left < 50) {
                // Aligned from top-left to bottom-right
                $content.style.setProperty('--top', `${position.top}%`);
                $content.style.setProperty('--left', `${position.left}%`);
            } else if (position.top < 50 && position.left >= 50) {
                // Aligned from top-right to bottom-left
                $content.style.setProperty('--top', `${position.top}%`);
                $content.style.setProperty('--right', `${100 - position.left}%`);
            } else if (position.top >= 50 && position.left < 50) {
                // Aligned from bottom-left to top-right
                $content.style.setProperty('--bottom', `${100 - position.top}%`);
                $content.style.setProperty('--left', `${position.left}%`);
            } else if (position.top >= 50 && position.left >= 50) {
                // Aligned from bottom-right to top-left
                $content.style.setProperty('--bottom', `${100 - position.top}%`);
                $content.style.setProperty('--right', `${100 - position.left}%`);
            }
        }
    }

    setEvents () {}
}

export { Hotspot };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$hotspot = $context.querySelectorAll('[data-hotspot="root"]');
        for (let i = 0; i < $$hotspot.length; i++) {
            const $hotspot = $$hotspot[i];

            const $hotspotAPI = new Hotspot($hotspot);
            $hotspotAPI.initialize();
        }
    }
});
